import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  MatDialogContent,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { TegelModule } from '@scania/tegel-angular-17';
import { ToastService } from '../../services/toast.service';
import { ToastState } from '../../enums/toast-state.enum';
import { SpinnerComponent } from '../spinner/spinner.component';

@Component({
  selector: 'app-modal',
  imports: [TegelModule, MatDialogModule, MatDialogContent, SpinnerComponent],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',
})
export class ModalComponent {
  @Input() title = '';
  @Input() form!: FormGroup;
  @Input() isValidationRequired = true;
  @Input() hideDefaultActions = false;
  @Input() onlyClose = false;
  @Input() saveMessage = 'Salvar';

  @Output() save = new EventEmitter<any>();

  isLoading = false;

  constructor(
    public dialogRef: MatDialogRef<ModalComponent>,
    private toast: ToastService,
  ) {}

  onSave() {
    if (!this.isValidationRequired) {
      this.isLoading = true;
      this.save.emit();
    } else if (this.form.valid) {
      this.isLoading = true;
      this.save.emit(this.form.value);
    } else {
      this.toast.showToast(
        ToastState.warning,
        'Preencha corretamente os campos!',
      );
      this.form.markAllAsTouched();
    }
  }

  cancel() {
    this.dialogRef.close();
  }

  stopLoading() {
    this.isLoading = false;
  }
}
